import {
  SUBMIT_CSAT,
  SUBMIT_CSAT_SUCCESS,
  SUBMIT_CSAT_FAILURE,
  HANDLE_CSAT_SUCCESS,
  HANDLE_CSAT_FAILURE,
} from "../action/types";

const INIT_STATE = {
  loading: false,
  showPopup: null,
  reason: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SUBMIT_CSAT:
      return { ...state, loading: true };
    case SUBMIT_CSAT_SUCCESS:
      return { ...state, loading: false, showPopup: false };
    case SUBMIT_CSAT_FAILURE:
      return { ...state, loading: false };
    case HANDLE_CSAT_SUCCESS:
      return {
        ...state,
        showPopup: action.payload?.showPopup ?? false,
        reason: action.payload?.reason ?? null,
      };
    case HANDLE_CSAT_FAILURE:
      return { ...state, showPopup: false };
    default:
      return state;
  }
};
